import { useQueryParam, StringParam } from "use-query-params";

export function useSearch(paramName: string = "search") {
  const [search, setSearch] = useQueryParam(paramName, StringParam);

  return [search || "", (s: string) => setSearch(s || undefined)] as const;
}
